import { GlobalResponseObject } from '@gtpl/shared-models/common-models';


export class GrnStatusWiseResponseModel extends GlobalResponseObject {
    active?: number;
    inActive?: number;
    total?: number;
}

